module.exports = "/_next/static/images/0d8a16531c08552d0b74157920195ce7-support-icon.svg.webp";